import { localisedValue } from "utils"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"
export const inventoryListingTransformer = response => {
  const inventoryData = response?.data?.map(inventory => {
    return {
      ...inventory,
      unitdetail: [
        localisedValue({ object: inventory?.ProjectSection, key: "breadcrumbTitle" }),
        localisedValue({ object: inventory?.Type, key: "name" }),
      ],
      bookingInfoColumn: {
        tokenAmount: inventory?.bookingInfo.minToken,
        partialDp: inventory?.bookingInfo?.pdpAmount,
        completeDp: inventory?.bookingInfo?.cdpAmount,
        pdpPercent: inventory?.bookingInfo?.pdpPercentage,
        cdpPercent: inventory?.bookingInfo?.cdpPercentage,
        minTokenUnit: inventory?.bookingInfo?.minTokenUnit,
      },
      privileges: createPrivilegeObject(inventory?.privileges),
    }
  })
  return {
    ...response,
    data: inventoryData,
  }
}
